<template>
  <a-layout>
    <a-layout-content class=" container py-12">
      <div class="row mb-10 xs:mb-2">
        <div class="w-1/3">
          <img src="@/assets/logo-wheezo-vert.svg" class="xs:h-16" />
        </div>
        <div class="w-2/3 flex justify-end sm:items-baseline">
          <a-button @click.prevent="logout">logout</a-button>
        </div>
      </div>
      <div class="row">
        <div class="px-4" style="width: 750px">
          <a-card class="my-32 text-center" :bordered="false">
            <h3 class="py-6">This page doesn't exist.</h3>
          </a-card>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer class="caption text-center">
      &copy; 2019 Respiri Limited. All rights reserved.
    </a-layout-footer>
  </a-layout>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { GET_EXPORT_BY_ID, IS_LOGGED_IN, LOGOUT } from '@/store';

@Component
export default class ErrorPage extends Vue {
  logout() {
    this.$store.dispatch(LOGOUT);
  }
}
</script>
<style lang="postcss" scoped>
.row {
  @apply flex justify-center;
}
</style>
